<template>
  <div class="mod-overlay">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar departamento' : 'Nuevo departamento' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <!-- Clave -->
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Clave"
              v-model="form.Clave"
              :disabled="isEdit"
              required
              maxlength="50"
              placeholder="Codigo del departamento"
            >
          </div>

          <!-- NombreDepartamento -->
          <div class="mod-field">
            <label for="NombreDepartamento">Nombre <span class="mod-required">*</span></label>
            <input
              type="text"
              id="NombreDepartamento"
              v-model="form.NombreDepartamento"
              required
              placeholder="Nombre del departamento"
            >
          </div>

          <!-- Descripcion -->
          <div class="mod-field">
            <label for="Descripcion">Descripcion</label>
            <input
              type="text"
              id="Descripcion"
              v-model="form.Descripcion"
              placeholder="Descripcion del departamento"
            >
          </div>

          <!-- Nivel -->
          <div class="mod-field">
            <label for="Nivel">Nivel</label>
            <input
              type="number"
              id="Nivel"
              v-model.number="form.Nivel"
              placeholder="0"
            >
          </div>

          <!-- Ceco1 -->
          <div class="mod-field">
            <label for="Ceco1">Ceco Principal</label>
            <input
              type="text"
              id="Ceco1"
              v-model="form.Ceco1"
              placeholder="Centro de costo 1"
            >
          </div>

          <!-- Ceco2 -->
          <div class="mod-field">
            <label for="Ceco2">Ceco 2</label>
            <input
              type="text"
              id="Ceco2"
              v-model="form.Ceco2"
              placeholder="Centro de costo 2"
            >
          </div>

          <!-- Ceco3 -->
          <div class="mod-field">
            <label for="Ceco3">Ceco 3</label>
            <input
              type="text"
              id="Ceco3"
              v-model="form.Ceco3"
              placeholder="Centro de costo 3"
            >
          </div>

          <!-- Ceco4 -->
          <div class="mod-field">
            <label for="Ceco4">Ceco 4</label>
            <input
              type="text"
              id="Ceco4"
              v-model="form.Ceco4"
              placeholder="Centro de costo 4"
            >
          </div>

          <!-- Ceco5 -->
          <div class="mod-field">
            <label for="Ceco5">Ceco 5</label>
            <input
              type="text"
              id="Ceco5"
              v-model="form.Ceco5"
              placeholder="Centro de costo 5"
            >
          </div>

          <!-- DepartamentoIdPadre -->
          <div class="mod-field">
            <label for="DepartamentoIdPadre">Departamento Padre Id</label>
            <input
              type="number"
              id="DepartamentoIdPadre"
              v-model.number="form.DepartamentoIdPadre"
              placeholder="0"
            >
          </div>

          <!-- EmpleadoIdResponsable -->
          <div class="mod-field">
            <label for="EmpleadoIdResponsable">Empleado Responsable Id</label>
            <input
              type="number"
              id="EmpleadoIdResponsable"
              v-model.number="form.EmpleadoIdResponsable"
              placeholder="0"
            >
          </div>

          <!-- EsActivo -->
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsActivo">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear departamento' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import departamentoService from './departamento.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createDepartamento } from './departamento.model';

export default {
  name: 'DepartamentoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createDepartamento(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.Clave || !this.form.NombreDepartamento) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }

      try {
        const result = await departamentoService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
